/**
 * GRAVITUS — scheda prodotto (ottobre 2026, rif. scheda "GRAM F" di bilanciadirect).
 *
 * 1. Carrello: un solo gestore del submit del form prodotto, sul document in
 *    fase di capture (arriva prima di product-form.js). Se ci sono servizi
 *    spuntati (verifica, rapporto di taratura), un indicatore o accessori
 *    scelti nei passi 2-3, oppure se si preme "Acquista ora", fa un'unica
 *    /cart/add.js con tutte le righe; altrimenti lascia fare a Dawn.
 *    "Acquista ora" poi porta al checkout, il carrello normale apre la notifica.
 * 2. Riepilogo e totale della colonna destra (<gravitus-buybox>).
 * 3. Cambio di variante: Dawn aggiorna prezzo, pulsanti e chip. Qui si allineano
 *    i nostri elementi che dipendono dalla variante (add-on, preventivo,
 *    riepilogo, tabella specifiche, stato "su richiesta").
 * 4. Data di consegna stimata.
 * 5. Tabella specifiche: filtri per opzione e "Seleziona" che sceglie il modello.
 * 6. FAQ: "Mostra di piu'".
 * 7. Visti di recente.
 */
(() => {
  // Il file e' incluso sia da main-product sia da gravitus-product-details: una sola esecuzione.
  if (window.__gravitusPdp) return;
  window.__gravitusPdp = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const syncData = (live, fresh) => {
    if (!live || !fresh) return;
    Array.from(fresh.attributes).forEach((attr) => {
      if (attr.name.startsWith('data-')) live.setAttribute(attr.name, attr.value);
    });
  };

  const extrasIn = (info) =>
    info ? Array.from(info.querySelectorAll('[data-gextra]:checked')).filter((input) => input.value) : [];

  /* ---------- 1. Carrello ---------- */
  const renderNotification = (cart, response) => {
    const sections = response.sections || {};
    const items = response.items || [];
    const productTarget = document.getElementById('cart-notification-product');
    if (productTarget && sections['cart-notification-product']) {
      const parsed = new DOMParser().parseFromString(sections['cart-notification-product'], 'text/html');
      productTarget.innerHTML = items
        .map((item) => {
          const node = parsed.querySelector(`[id="cart-notification-product-${item.key}"]`);
          return node ? node.outerHTML : '';
        })
        .join('');
    }
    ['cart-notification-button', 'cart-icon-bubble'].forEach((id) => {
      const target = document.getElementById(id);
      if (!target || !sections[id]) return;
      const parsed = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });
    if (cart.header) cart.header.reveal();
    cart.open();
  };

  document.addEventListener(
    'submit',
    (evt) => {
      const productForm = evt.target.closest && evt.target.closest('product-form');
      if (!productForm) return;
      const info = productForm.closest('product-info') || document;
      const buyNow = Boolean(evt.submitter && evt.submitter.hasAttribute('data-buy-now'));
      // Scelte obbligatorie o con condizioni (piano taratura, ritiro e riconsegna):
      // finche' non sono a posto non si compra, nemmeno con il flusso standard di Dawn.
      const blocked = Array.from(info.querySelectorAll('gravitus-omologazione')).find((addon) => addon.blocked);
      if (blocked) {
        evt.preventDefault();
        evt.stopPropagation();
        const focus = blocked.querySelector('[data-gaccept]') || blocked.querySelector('input[type="radio"]');
        const msg = blocked.querySelector('[data-gaccept-error]');
        if (msg) msg.hidden = false;
        focus?.focus();
        blocked.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      const addons = window.GravitusAddons ? window.GravitusAddons.activeIn(info) : [];
      const extras = extrasIn(info);
      if (!buyNow && !addons.length && !extras.length) return; // nessuna aggiunta: fa Dawn

      evt.preventDefault();
      evt.stopPropagation();
      const button = evt.submitter || productForm.querySelector('[type="submit"]');
      if (button.getAttribute('aria-disabled') === 'true') return;


      const formData = new FormData(evt.target);
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      let items;
      if (window.GravitusAddons) {
        items = window.GravitusAddons.buildItems(formData, addons);
      } else {
        const properties = {};
        for (const [name, value] of formData.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        }
        items = [{ id: formData.get('id'), quantity, properties }];
      }
      extras.forEach((input) => items.push({ id: input.value, quantity }));

      const spinner = button.querySelector('.loading__spinner');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      spinner?.classList.remove('hidden');
      if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();

      const cart = buyNow ? null : productForm.cart;
      const body = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      const done = () => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        spinner?.classList.add('hidden');
      };

      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            done();
            if (typeof productForm.handleErrorMessage === 'function') {
              productForm.handleErrorMessage(response.description || response.message);
            }
            return;
          }
          if (buyNow) {
            window.location.href = `${root}checkout`;
            return;
          }
          done();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gravitus-pdp', productVariantId: formData.get('id'), cartData: response });
          }
          if (cart) renderNotification(cart, response);
          else window.location.href = window.routes ? window.routes.cart_url : `${root}cart`;
        })
        .catch(done);
    },
    true
  );

  /* ---------- 2. Riepilogo e totale ---------- */
  class GravitusBuybox extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info') || document;
      this.update = this.update.bind(this);
      this.info.addEventListener('change', this.update);
      this.info.addEventListener('gravitus:choice', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.info.removeEventListener('change', this.update);
      this.info.removeEventListener('gravitus:choice', this.update);
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || 'it', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
          minimumFractionDigits: cents % 100 ? 2 : 0,
        }).format(cents / 100);
      } catch (e) {
        return `€${(cents / 100).toFixed(2)}`;
      }
    }

    update() {
      const base = Number(this.dataset.variantPrice) || 0;
      let total = base;
      this.querySelectorAll('[data-gsum-addon]').forEach((row) => {
        const addon = this.info.querySelector(`gravitus-omologazione[data-addon="${row.dataset.gsumAddon}"]`);
        const on = Boolean(addon && addon.active);
        row.hidden = !on;
        if (on) {
          total += Number(addon.servicePrice) || 0;
          const v = row.querySelector('.gsum__v');
          if (v && addon.selectedLabel) v.textContent = addon.selectedLabel;
        }
      });
      ['indicatore', 'accessori'].forEach((kind) => {
        const row = this.querySelector(`[data-gsum-kind="${kind}"]`);
        const chosen = Array.from(this.info.querySelectorAll(`[data-gextra][data-gextra-kind="${kind}"]:checked`));
        chosen.forEach((input) => (total += Number(input.dataset.price) || 0));
        if (!row) return;
        const step = this.info.querySelector(`[data-gstep="${kind}"]`);
        row.hidden = !step;
        const value = row.querySelector('.gsum__v');
        if (value) value.textContent = chosen.length ? chosen.map((i) => i.dataset.label).join(', ') : '—';
      });
      const out = this.querySelector('[data-gsum-total]');
      if (out) out.textContent = base > 0 ? this.money(total) : this.dataset.onRequest;
    }
  }
  if (!customElements.get('gravitus-buybox')) customElements.define('gravitus-buybox', GravitusBuybox);

  /* ---------- 3. Cambio di variante ---------- */
  const syncAddons = (info, html) => {
    const live = new Map();
    info.querySelectorAll('gravitus-omologazione[data-addon]').forEach((el) => live.set(el.dataset.addon, el));
    const fresh = Array.from(html.querySelectorAll('product-info gravitus-omologazione[data-addon]'));
    let anchor = null;
    fresh.forEach((next) => {
      const current = live.get(next.dataset.addon);
      if (current) {
        // la scelta resta la stessa (stesso valore del radio), cambia solo la fascia
        const chosen = current.querySelector('.gravitus-omolog__checkbox:checked');
        if (chosen) {
          const same = next.querySelector(`.gravitus-omolog__checkbox[value="${chosen.value}"]`);
          if (same) {
            same.checked = true;
          } else {
            const no = next.querySelector('input[type="radio"][value="0"]');
            if (no) no.checked = true;
          }
        }
        const accept = current.querySelector('[data-gaccept]');
        const freshAccept = next.querySelector('[data-gaccept]');
        if (accept && freshAccept) freshAccept.checked = accept.checked;
        current.replaceWith(next);
        live.delete(next.dataset.addon);
      } else if (anchor) {
        anchor.after(next);
      }
      anchor = next;
    });
    live.forEach((el) => el.remove());
  };

  const setOnRequest = (productInfo, variant) => {
    if (!productInfo) return;
    productInfo.classList.toggle('is-on-request', Boolean(variant) && Number(variant.price) === 0);
    // Usato: variante con opzione «Condizione: Usato» (giro 2026-10-21)
    const used = Boolean(variant) && (variant.options || []).some((o) => /^(usato|used|gebraucht|occasion|usado)/i.test(String(o)));
    productInfo.classList.toggle('is-used', used);
  };

  document.querySelectorAll('product-info').forEach((info) => {
    const json = info.querySelector('variant-selects [data-selected-variant]');
    if (!json) return;
    try {
      setOnRequest(info, JSON.parse(json.textContent));
    } catch (e) {
      /* json assente o malformato: nessuno stato da applicare */
    }
  });

  const markSpecColumn = (variantTitle) => {
    document.querySelectorAll('gravitus-spec-table').forEach((table) => {
      table.querySelectorAll('th[data-gspec-col]').forEach((th) => {
        const on = th.textContent.trim() === variantTitle;
        th.classList.toggle('is-current', on);
        const col = th.dataset.gspecCol;
        table.querySelectorAll(`[data-gspec-select]`).forEach((btn) => {
          if (btn.closest('td')?.dataset.gspecCol === col) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const { sectionId, html, variant } = data || {};
      if (!html) return;
      const info = document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (!info) return;

      const liveQuote = info.querySelectorAll('gravitus-quote-add');
      const freshQuote = html.querySelectorAll('product-info gravitus-quote-add');
      liveQuote.forEach((el, i) => {
        syncData(el, freshQuote[i]);
        el.querySelector('button')?.classList.remove('is-added');
      });

      syncAddons(info, html);

      // «Completa la tua bilancia» dipende dal modello (peso e certificato giusti per
      // portata e divisione): si prende la versione del server e si tengono le spunte
      // sugli articoli ancora proposti.
      const acc = info.querySelector('[data-gstep="accessori"]');
      const freshAcc = html.querySelector('product-info [data-gstep="accessori"]');
      if (acc && freshAcc) {
        const checked = new Set(Array.from(acc.querySelectorAll('[data-gextra]:checked')).map((i) => i.value));
        freshAcc.querySelectorAll('[data-gextra]').forEach((i) => {
          i.checked = checked.has(i.value);
        });
        acc.replaceWith(freshAcc);
      }

      const box = info.querySelector('gravitus-buybox');
      const freshBox = html.querySelector('product-info gravitus-buybox');
      if (box && freshBox) {
        syncData(box, freshBox);
        const model = box.querySelector('[data-gsum-model]');
        const freshModel = freshBox.querySelector('[data-gsum-model]');
        if (model && freshModel) model.textContent = freshModel.textContent;
        box.update();
      }
      setOnRequest(info, variant);
      if (variant) markSpecColumn(variant.title);
    });
  }

  /* ---------- 4. Data di consegna stimata ---------- */
  const easterMonday = (year) => {
    // Computus (algoritmo di Gauss/Meeus) + 1 giorno
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day + 1);
  };
  const isHoliday = (date) => {
    const md = `${date.getMonth() + 1}-${date.getDate()}`;
    const fixed = ['1-1', '1-6', '4-25', '5-1', '6-2', '8-15', '11-1', '12-8', '12-25', '12-26'];
    if (fixed.includes(md)) return true;
    const em = easterMonday(date.getFullYear());
    return em.getMonth() === date.getMonth() && em.getDate() === date.getDate();
  };
  const isWorkday = (date) => date.getDay() !== 0 && date.getDay() !== 6 && !isHoliday(date);

  document.querySelectorAll('[data-geta]').forEach((box) => {
    const numbers = (box.dataset.tempi || '').match(/\d+/g);
    const out = box.querySelector('[data-geta-date]');
    if (!numbers || !out) return;
    const days = Math.max(...numbers.map(Number));
    const now = new Date();
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const beforeCutoff = isWorkday(date) && now.getHours() < 12;
    if (!beforeCutoff) {
      do date.setDate(date.getDate() + 1);
      while (!isWorkday(date));
    }
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      if (isWorkday(date)) left -= 1;
    }
    const label = date.toLocaleDateString(box.dataset.locale || 'it', { weekday: 'short', day: 'numeric', month: 'long' });
    out.textContent = `${beforeCutoff ? out.dataset.textBefore : out.dataset.textAfter} `;
    const strong = document.createElement('strong');
    strong.textContent = label;
    out.appendChild(strong);
    out.hidden = false;
  });

  /* ---------- 5. Tabella specifiche ---------- */
  class GravitusSpecTable extends HTMLElement {
    connectedCallback() {
      this.filters = Array.from(this.querySelectorAll('[data-gspec-filter]'));
      this.filters.forEach((select) => select.addEventListener('change', () => this.apply()));
      this.querySelector('[data-gspec-reset]')?.addEventListener('click', () => {
        this.filters.forEach((select) => (select.value = ''));
        this.apply();
      });
      this.querySelectorAll('[data-gspec-select]').forEach((btn) => {
        btn.addEventListener('click', () => this.select(btn.dataset.gspecSelect));
      });
    }

    apply() {
      const wanted = this.filters.map((select) => select.value);
      let visible = 0;
      this.querySelectorAll('th[data-gspec-col]').forEach((th) => {
        const values = (th.dataset.values || '').split('|');
        const show = wanted.every((w, i) => !w || values[i] === w);
        if (show) visible += 1;
        this.querySelectorAll(`[data-gspec-col="${th.dataset.gspecCol}"]`).forEach((cell) => (cell.hidden = !show));
      });
      // Le righe con una cella sola (dati comuni) seguono il numero di colonne visibili.
      this.querySelectorAll('.gspec__span').forEach((cell) => (cell.colSpan = Math.max(visible, 1)));
      const empty = this.querySelector('[data-gspec-empty]');
      if (empty) empty.hidden = visible > 0;
    }

    /* Sceglie il modello spuntando i chip delle opzioni in alto, poi un solo
       "change": Dawn legge tutti i valori selezionati e carica la variante. */
    select(valueIds) {
      const info = document.querySelector(`product-info[data-section="${this.dataset.section}"]`) || document.querySelector('product-info');
      const selects = info && info.querySelector('variant-selects');
      if (!selects) return;
      let last = null;
      valueIds.split(',').forEach((id) => {
        const input = selects.querySelector(`input[data-option-value-id="${id}"]`);
        if (input) {
          input.checked = true;
          last = input;
        }
        const option = selects.querySelector(`option[data-option-value-id="${id}"]`);
        if (option) {
          option.selected = true;
          last = option.closest('select');
        }
      });
      if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
      info.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  if (!customElements.get('gravitus-spec-table')) customElements.define('gravitus-spec-table', GravitusSpecTable);

  /* ---------- 6. FAQ ---------- */
  document.querySelectorAll('[data-gfaq]').forEach((group) => {
    const more = group.querySelector('[data-gfaq-more]');
    const extra = group.querySelectorAll('[data-gfaq-extra]');
    if (!more) return;
    if (!extra.length) {
      more.remove();
      return;
    }
    const less = more.textContent;
    more.addEventListener('click', () => {
      const open = more.getAttribute('aria-expanded') !== 'true';
      extra.forEach((item) => (item.hidden = !open));
      more.setAttribute('aria-expanded', String(open));
      more.textContent = open ? more.dataset.less || less : less;
    });
  });

  /* ---------- 7. Visti di recente ---------- */
  class GravitusRecent extends HTMLElement {
    connectedCallback() {
      const key = 'gravitus-recent';
      const handle = this.dataset.handle;
      let list = [];
      try {
        list = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        list = [];
      }
      const others = list.filter((h) => h !== handle).slice(0, 4);
      try {
        localStorage.setItem(key, JSON.stringify([handle, ...list.filter((h) => h !== handle)].slice(0, 8)));
      } catch (e) {
        /* storage non disponibile: nessuna cronologia */
      }
      if (!others.length) return;
      const target = this.querySelector('[data-grecent-list]');
      const base = this.dataset.root || '/';
      Promise.all(
        others.map((h) =>
          fetch(`${base}products/${encodeURIComponent(h)}?view=card`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      ).then((cards) => {
        const html = cards.filter((c) => c.trim()).map((c) => `<li class="grid__item">${c}</li>`).join('');
        if (!html) return;
        target.innerHTML = html;
        this.hidden = false;
      });
    }
  }
  if (!customElements.get('gravitus-recent')) customElements.define('gravitus-recent', GravitusRecent);
})();

/* "Mostra tutti" per indicatori e accessori (giro 2026-10-21) */
document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-gmore-toggle]');
  if (!btn) return;
  const box = btn.previousElementSibling && btn.previousElementSibling.matches('[data-gmore-box]') ? btn.previousElementSibling : null;
  if (!box) return;
  const open = btn.getAttribute('aria-expanded') !== 'true';
  box.querySelectorAll('[data-gmore-item]').forEach((el) => {
    el.hidden = !open;
  });
  if (!btn.dataset.labelMore) btn.dataset.labelMore = btn.textContent.trim();
  btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});
